import { Field } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/types';
import { CJPDFSettings, PrintCJDirection } from 'types/cj';
import { CahierJournalView } from 'containers/CahierJournal/types';

interface Props {
  lng: string;
  tz: string;
  classroomsId: string[];
  collapsedDays: string[];
  fieldsToDisplay: Field[];
  hideEvents: boolean;
  settings: CJPDFSettings;
  view: CahierJournalView | 'days';
}

export function isLandscape(
  landscapeParam: boolean,
  view: CahierJournalView | 'days',
  direction: PrintCJDirection,
) {
  if (view === 'week' && direction === 'next') {
    return true;
  }
  return landscapeParam;
}

export function buildCJPDFParams({
  lng,
  tz,
  classroomsId,
  collapsedDays,
  fieldsToDisplay,
  hideEvents,
  settings,
  view,
}: Props) {
  const landscape = isLandscape(
    settings.landscape || false,
    view,
    settings.direction || 'next',
  );
  const params = new URLSearchParams({
    lng,
    tz,
    direction: settings.direction || 'below',
    size: (settings.size || 14).toString(),
    breakinsideavoid: settings.breakinsideavoid ? 'true' : 'false',
    condensed: settings.condensed ? 'true' : 'false',
    displaybilan: settings.displaybilan ? 'true' : 'false',
    displaylength: settings.displaylength ? 'true' : 'false',
    displaymaterialssum: settings.displaymaterialssum ? 'true' : 'false',
    displayElevesGroups: settings.displayElevesGroups ? 'true' : 'false',
    displaytags: settings.displaytags ? 'true' : 'true',
    hideclassroombar: settings.disableClassroomBar ? 'true' : 'false',
    hidePlannerEvents: hideEvents ? 'true' : 'false',
    mainTagColor: settings.mainTagColor || '',
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 4).toString(),
    marginBottom: (settings.marginBottom ?? 4).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
    displayTeacherName: settings.displayTeacherName ? 'true' : 'false',
    landscape: landscape ? 'true' : 'false',
    seanceTitleStyle: settings.seanceTitleStyle || 'underlined',
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  if (fieldsToDisplay.length > 0) {
    fieldsToDisplay.forEach(field => params.append('fieldsToDisplay[]', field));
  }

  if (classroomsId.length > 0) {
    params.set('classrooms', classroomsId.join(','));
  }

  if (collapsedDays.length > 0) {
    params.set('collapsedDays', collapsedDays.join(','));
  }
  return params;
}
